import PropTypes from 'prop-types';
import CustomListNode from './CustomListNode';

export function CustomListItems({ nodes, path = [], customListId }) {
  return (
    <div>
      {nodes.map((item, index) => {
        return (
          <CustomListNode
            key={item.id}
            nodeData={item}
            nodeIndex={index}
            path={path}
            customListId={customListId}
            renderChildNodes={() =>
              item.nodes?.length > 0 ? (
                <CustomListItems path={[...path, item.id]} nodes={item.nodes} customListId={customListId} />
              ) : null
            }
          />
        );
      })}
    </div>
  );
}

CustomListItems.propTypes = {
  nodes: PropTypes.array,
  path: PropTypes.array,
  customListId: PropTypes.string,
};
